import { Component, OnInit, ViewChild } from '@angular/core';

import { AuthService, AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';

import { environment } from '../environments/environment';
// import { VERSION } from '../environments/version';
import { MatSidenav } from '@angular/material/sidenav';
import { Contacts } from '@usimweb/core/models';
import { ControlCachingService, SideNavService } from '@usimweb/core/services';

@Component({
    selector: 'usimweb-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  @ViewChild('sidenav', { static: true }) sidenav!: MatSidenav;

  public contacts: Contacts[] = [];

  public app = 'Foaming';
  public user = '';

  constructor(
    private authService: AuthService,
    private authHandler: AuthHandler,
    private sideNavService: SideNavService,
    private apiService: ApiService,
    private controlCacheService: ControlCachingService
  ) {
    //console.log(`Application version is: ${VERSION.hash}`);
  }

  ngOnInit(): void {
    if (environment.deployment === 'appstore') {
      if (this.authService.accessToken === undefined || this.authService.accessToken === 'undefined') {
        // check if access token is expired
        // call for initializationRequest()

        const subscription = this.authService.initializationRequest().subscribe(() => {
          this.authHandler.isAuthenticatedListener.next(true);
          subscription.unsubscribe();
          //this.controlCacheService.handleCaching(VERSION.hash);
        });
      } else {
        this.authService.setCookies();
        this.authHandler.isAuthenticatedListener.next(true);
        //this.controlCacheService.handleCaching(VERSION.hash);
      }
    } else {
      this.authHandler.isAuthenticatedListener.next(true);
    }

    this.sideNavService.setSidenav(this.sidenav);

    // this.authHandler.authListener();

    this.apiService.getContactRequests().subscribe((contacts: Contacts[]) => {
      if (contacts) {
        this.sideNavService.requestContacts(contacts);
        this.contacts = contacts;
      }
    });

    // this.sideNavService.updateCallback.pipe(skip(1)).subscribe((contacts: Contacts[]) => {

    // });

    this.getUser();
  }

  private getUser() {
    this.authHandler.isAuthenticatedListener.subscribe((authenticated: boolean) => {
      if (authenticated) {
        this.user = AuthHandler.userName || '';
      }
    });
  }

  public logout() {
    this.authHandler.logout();
  }
}
